import { render, staticRenderFns } from "./index_RC.vue?vue&type=template&id=5f8dea9f&scoped=true"
import script from "./index_RC.vue?vue&type=script&lang=js"
export * from "./index_RC.vue?vue&type=script&lang=js"
import style0 from "./index_RC.vue?vue&type=style&index=0&id=5f8dea9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8dea9f",
  null
  
)

export default component.exports